export function fetchArticle(apiUrl, accessToken, nid) {

  return fetch(`${apiUrl}/v1/articles/${nid}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}